<template>
  <div>
    <Overlay :overlay="overlay" />
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <VideoCallDialog
      :VideoCallDialog="VideoCallDialog"
      @clicked="VideoCallEmit"
    />
    <ViolationAcknowledged
      :Acknowledged="Acknowledged"
      @clicked="AcknowledgedEmit"
    />
    <CarDetailsDialog
      :CardetailsDialog="CardetailsDialog"
      @clicked="CarDialogEmit"
      :StoreObj="StoreObj"
    />
    <AddViolationDialog
      :license_plate_number="license_plate_number"
      :dialogAddViolation="dialogAddViolation"
      @clicked="dialogAddViolationEmit"
    />
    <ManyCarDetails
      :AnyCarDetailsDialog="AnyCarDetailsDialog"
      :CarsArray="ManyCarsArray"
      :UserName="UserName"
      @clicked="AnyCarDialogEmit"
    />
    <FirstNotification
      :MessageNotification="MessageNotification"
      @clicked="FirstMessageEmit"
    />
    <AlertNotification
      :WarningNotification="WarningNotification"
      @clicked="AlertDialogEmit"
    />

    <v-container fluid fill-height class="pa-0">
      <v-img src="@/assets/blurBg1.jpg" cover class="responsive-image">
        <v-row align="center" justify="center">
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-card-text>
              <v-card class="pa-4 elevation-0" color="transparent">
                <v-form ref="formDefaultState">
                  <v-row
                    justify="center"
                    v-if="
                      this.$store.getters.get_current_user_details.user_name !=
                        undefined &&
                      this.$store.getters.get_current_user_details.user_name !=
                        '' &&
                      this.$store.getters.get_current_user_details
                        .user_status == 'ACTIVE'
                    "
                  >
                    <v-col
                      cols="12"
                      xs="12"
                      sm="12"
                      md="6"
                      class="pb-0"
                      align="center"
                    >
                      <audio
                        ref="backgroundAudio"
                        :src="audioSrc"
                        preload="auto"
                        loop
                      ></audio>
                      <v-card-actions class="pa-0">
                        <v-autocomplete
                          dense
                          solo
                          class="mt-4"
                          label="State"
                          filled
                          v-model="default_state"
                          :items="USAStates"
                          item-text="name"
                          item-value="name"
                          :rules="[(v) => !!v || 'Required']"
                        ></v-autocomplete>
                        <v-btn
                          medium
                          depressed
                          tile
                          :loading="loadingDefaultState"
                          width="100px"
                          class="mt-n2 ml-2 text-capitalize"
                          color="primary"
                          @click="validateDefaultStateMethod()"
                        >
                          <div class="fontsize12px">Default State</div>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-form>
                <v-form ref="form">
                  <v-row
                    justify="center"
                    v-if="
                      this.$store.getters.get_current_user_details.user_name !=
                        undefined &&
                      this.$store.getters.get_current_user_details.user_name !=
                        '' &&
                      this.$store.getters.get_current_user_details
                        .user_status == 'ACTIVE'
                    "
                  >
                    <v-col cols="12" xs="12" sm="12" md="6" class="py-0">
                      <v-card-actions class="pa-0">
                        <v-text-field
                          dense
                          outlined
                          label="License Number"
                          v-model="license_plate_number"
                          :rules="[(v) => !!v || 'Required']"
                          class="mt-2 mr-6"
                          background-color="white"
                          @keydown="handleKeyDown"
                        ></v-text-field>
                        <v-btn
                          :medium="$vuetify.breakpoint.lg ? 'medium' : 'small'"
                          tile
                          depressed
                          class="mt-n4 ml-n4 BTNradius"
                          width="100px"
                          color="primary"
                          @click="validateMethod('NUMBER_PLATE')"
                        >
                          <v-icon small>mdi-magnify</v-icon>
                          <div class="fontsize11px">Search</div>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-form>

                <video id="myVideo" width="1" height="1" controls>
                  <source
                    src="@/assets/NotificationVideo.mp4"
                    type="video/mp4"
                  />
                </video>

                <video id="myVideo1" width="1" height="1" controls>
                  <source src="@/assets/makhsvideo1.mp4" type="video/mp4" />
                </video>

                <!-- <audio id="myVideo1" muted preload="auto">
                  <source src="@/assets/MIHS_Female.mp3" type="audio/mp3" />
                </audio> -->
                <v-card
                  v-if="driver_status == 'DRIVER_HIDDEN'"
                  class="elevation-0 font-weight-bold text-center overflow-y-auto"
                  color="transparent"
                >
                  <div align="center">
                    <v-img max-width="200px" src="@/assets/user.png"></v-img>
                  </div>
                  <div>Driver Has Hidden His Profile Details</div>
                  <v-btn
                    class="mt-3"
                    :loading="loading"
                    tile
                    color="primary"
                    @click="validateMethod('REQUEST_ACCESS')"
                    >Request Access</v-btn
                  >
                </v-card>

                <v-card
                  outlined
                  v-if="
                    driver_status == 'DRIVER_FOUND' &&
                    $store.getters.get_motorist_again == false &&
                    $store.getters.get_motorist_boolean == true
                  "
                  :class="
                    $vuetify.breakpoint.lg ? 'elevation-5' : 'elevation-2'
                  "
                >
                  <v-toolbar dense class="elevation-0" height="30px">
                    <v-spacer />
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          icon
                          large
                          color="blueColorVariant9"
                          class="mt-4"
                          @click="UndoProfileSearch()"
                          ><v-icon>mdi-close</v-icon></v-btn
                        >
                      </template>
                      <span>Close</span>
                    </v-tooltip>
                  </v-toolbar>
                  <v-row justify="center">
                    <v-col cols="12" md="7" sm="12" xs="12">
                      <v-row
                        ><v-col
                          cols="12"
                          md="12"
                          xs="12"
                          sm="12"
                          class="d-flex justify-space-around ma-1"
                          align="center"
                        >
                          <div align="center" class="mt-8">
                            <div class="">
                              <v-img
                                v-if="
                                  profile_pic_url == '' ||
                                  profile_pic_url == null
                                "
                                width="100px"
                                src="@/assets/LoadingImage.gif"
                              ></v-img>
                              <v-img
                                v-else
                                :src="profile_pic_url"
                                rounded
                                width="150px"
                                height="150px"
                                class="ma-1 ImageRadius"
                              ></v-img>
                            </div>
                            <div class="font-weight-bold fontsize16px">
                              {{ userDetailsObject.user_name }}
                            </div>
                            <div class="font-weight-bold">
                              {{ userDetailsObject.user_email_id }}
                            </div>
                            <div class="">
                              {{ userDetailsObject.user_country_code }}
                              {{ userDetailsObject.user_phone_number }}
                            </div>
                            <div>
                              <v-icon small color="green"
                                >mdi-map-marker-radius</v-icon
                              >{{ address }}
                            </div>
                            <div class="">
                              <v-icon small color="green" class="mb-1 mr-1"
                                >mdi-checkbox-marked-circle</v-icon
                              >Biometric Confirmed
                            </div>
                            <div class="red--text font-weight-bold">
                              {{ userDetailsObject.user_weapon }}
                            </div>
                            <div class="ml-6 mt-n1">
                              Vehicle Details:<v-btn
                                icon
                                @click="
                                  CarDetailsDialog(
                                    $store.getters.get_car_details
                                  )
                                "
                                ><v-icon medium color="blueColorVariant9"
                                  >mdi-information-outline</v-icon
                                ></v-btn
                              >
                            </div>

                            <v-btn
                              small
                              color="primary"
                              @click="dialogAddViolation = true"
                              class=""
                            >
                              <v-icon>mdi-share</v-icon>
                              Send Violation
                            </v-btn>
                            <v-btn
                              small
                              color="primary"
                              @click="ChatMethod()"
                              class="ma-3"
                            >
                              <v-icon class="ma-2">mdi-whatsapp</v-icon>
                              chat with motorist
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <v-card class="elevation-0 ma-2" outlined tile>
                        <v-row class="pa-2">
                          <v-col
                            v-for="(item, index) in imageArray"
                            :key="index"
                            cols="12"
                            sm="6"
                            md="6"
                            xs="6"
                            align="center"
                          >
                            <v-img
                              v-if="
                                item.imageUrl == '' || item.imageUrl == null
                              "
                              width="100px"
                              src="@/assets/LoadingImage.gif"
                            ></v-img>
                            <div
                              v-else
                              class="font-weight-bold"
                              :class="
                                $vuetify.breakpoint.name != 'sm' &&
                                $vuetify.breakpoint.name != 'md' &&
                                $vuetify.breakpoint.name != 'xs'
                                  ? 'fontsize15px'
                                  : 'fontsize10px'
                              "
                            >
                              {{ item.view }}
                            </div>

                            <v-img
                              width="250px"
                              class="mt-1 imgStyle"
                              contain
                              :src="item.imageUrl"
                              @click="OpenImageDialog(item)"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
                <v-row justify="center" class="mt-10">
                  <v-col
                    v-if="AllCarDetails == true"
                    align="center"
                    cols="12"
                    md="6"
                    xs="12"
                    sm="12"
                  >
                    <v-card>
                      <v-toolbar
                        dense
                        color="blueColorVariant9"
                        class="white--text elevation-0"
                        >Nearby Unhidden Motorists</v-toolbar
                      >
                      <v-data-table
                        dense
                        :items="GetAllMotoristsList"
                        :headers="DetailsHeaders"
                        hide-default-footer
                      >
                        <template
                          v-slot:[`item.notified_by_user_name`]="{ item }"
                        >
                          <div class="font-weight-bold">
                            {{ item.notified_by_user_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.profile_pic_url`]="{ item }">
                          <v-img
                            width="40px"
                            height="40px"
                            class="ma-1"
                            :src="item.profile_pic_url"
                          ></v-img>
                        </template>
                        <template v-slot:[`item.created_on`]="{ item }">
                          <div class="font-weight-bold">
                            {{
                              new Date(
                                item.created_on * 1000
                              ).toLocaleTimeString()
                            }}
                          </div>
                        </template>
                        <template v-slot:[`item.View_more`]="{ item }"
                          ><v-btn
                            small
                            dark
                            depressed
                            @click="ViewDetailsMethod(item)"
                            color="primary"
                            style="text-transform: none"
                            >{{
                              getLicensePlateText(item.license_plate_number)
                            }}
                          </v-btn></template
                        >
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </v-col>
        </v-row>
      </v-img>
    </v-container>

    <v-dialog v-model="ImageDialog" width="800px">
      <v-card color="white" tile>
        <div ref="zoomContainer" @wheel="handleZoom">
          <v-img :src="ImageSrc" :style="imageStyle" width="800px" />
        </div> </v-card
    ></v-dialog>
    <v-dialog v-model="ViolateOK" width="400px">
      <v-card color="white">
        <div>Motorist Acknowledged Violation</div>
      </v-card></v-dialog
    >
    <v-dialog v-model="AutoPlayDialog" persistent width="400px">
      <v-card color="white">
        <div align="center" class="pt-2">
          <v-img
            src="@/assets/AudioImage1.png"
            width="100px"
            class="mt-2"
          ></v-img>
        </div>
        <div align="center" class="mt-4 font-weight-bold">
          Enable Audio Autoplay to get notification
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="mt-3 text-capitalize"
            @click.stop="AudioPlay()"
            >Enable Audio</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>
<script>
import Overlay from "@/components/Extras/Overlay.vue";
import Snackbar from "@/components/Extras/Snackbar.vue";
import CarDetailsDialog from "@/components/Extras/CarDetailsDialog.vue";

import { GetCurrentUserDetails } from "@/mixins/GetCurrentUserDetails.js";
import { GetVehicleDetails } from "@/mixins/GetVehicleDetails.js";
import { updateProfileDetails } from "@/mixins/Methods/updateProfileDetails.js";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
import { GetAllNearMotorist } from "@/mixins/Methods/PoliceNearDetails.js";
import { GetNearCarDetails } from "@/mixins/Methods/GetCarNearDetails.js";
import { ViewImageDetails } from "@/mixins/Methods/ViewImageNotification.js";

import { SubscribeGetNotifications } from "@/graphql/subscriptions.js";
import { RequestForProfile } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

import AddViolationDialog from "@/components/Violations/Dialogs/AddViolationDialog.vue";
import ViolationAcknowledged from "@/components/Violations/Dialogs/ViolationAcknoledged.vue";
import FirstNotification from "@/components/Extras/MessageByMotorist.vue";
import ManyCarDetails from "@/components/Extras/AnyCarDetailDialog.vue";
// import whatsappNotificationSound from "@/assets/whatsapp_notification.mp3";
// import ActivatedVoice from "@/assets/MIHS_Female.mp3";
import VideoCallDialog from "@/components/Extras/VideoCallDialog.vue";
import AlertNotification from "@/components/Extras/WarningDialog.vue";
import { RecieveVideoCallSub } from "@/mixins/Chat/VideoCallSub.js";

import { RecordDetailsOfPolice } from "@/mixins/Methods/RecordDetails.js";
import axios from "axios";

export default {
  props: {},
  components: {
    Overlay,
    Snackbar,
    AddViolationDialog,
    CarDetailsDialog,
    ManyCarDetails,
    ViolationAcknowledged,
    FirstNotification,
    VideoCallDialog,
    AlertNotification,
  },
  mixins: [
    GetVehicleDetails,
    updateProfileDetails,
    GetCurrentUserDetails,
    GenerateS3URL,
    GetAllNearMotorist,
    GetNearCarDetails,
    ViewImageDetails,
    RecieveVideoCallSub,
    RecordDetailsOfPolice,
  ],
  data: () => ({
    audioSrc: require("@/assets/whatsapp_notification.mp3"),
    audioPlayed: false,
    cardHeight: 0,
    userAndCarDetailsTab: 0,
    zoom: 1,
    offsetX: 0,
    offsetY: 0,

    ImageURL: "",
    default_state: "",
    driver_status: "",
    license_plate_number: "",
    profile_pic_url: "",

    overlay: false,
    loading: false,
    AllCarDetails: false,
    dialogAddViolation: false,
    loadingDefaultState: false,
    CardetailsDialog: false,
    AnyCarDetailsDialog: false,
    ImageDialog: false,
    ViolateOK: false,
    Chatdialog: false,
    Acknowledged: false,
    WarningNotification: false,
    MessageNotification: false,
    VideoCallDialog: false,
    AutoPlayDialog: false,

    hasUserInteracted: true,

    SnackBarComponent: {},
    currentUserOject: {},
    SubscribeObject: null,
    StoreObj: {},

    latitude: null,
    longitude: null,
    address: null,
    ImageSrc: "",
    TableImage: "",
    UserName: "",
    USAStates: [],
    ManyCarsArray: [],
    CardetailsNear: [],
    subscription: [],
    currentLocation: {
      lat: "",
      lng: "",
    },
    imageArray: [
      {
        view: "Driver's License Front",
        imageUrl: "",
      },
      {
        view: "Driver's License Back",
        imageUrl: "",
      },
      {
        view: "Vehicle Registration Certificate",
        imageUrl: "",
      },
      {
        view: "Vehicle Insurance Certificate",
        imageUrl: "",
      },
    ],
    DetailsHeaders: [
      {
        text: "Motorist Name",
        value: "notified_by_user_name",
        align: "",
        sortable: false,
      },
      {
        text: "Unhidden Time",
        value: "created_on",
        sortable: false,
      },
      // {
      //   text: "Image",
      //   value: "profile_pic_url",
      //   align: "",
      // },
      {
        text: "Plate Number",
        value: "View_more",
        align: "center",
        sortable: false,
      },
    ],
  }),
  async created() {
    // setTimeout(() => {
    //   if (this.$store.getters.get_subscription_status == true) {
    //     this.subscribeToNewRequest();
    //     console.log("Subscribed");
    //   }
    // }, 2000);
    // this.subscribeToRecieveVideoCall();
  },
  // beforeDestroy() {
  //   if (
  //     this.$store.getters.get_subscription_status == false &&
  //     this.SubscribeObject
  //   ) {
  //     this.SubscribeObject.unsubscribe();
  //   }
  // },
  computed: {
    imageStyle() {
      return {
        transform: `scale(${this.zoom})`,
        transformOrigin: `${this.offsetX}px ${this.offsetY}px`,
      };
    },
  },
  watch: {
    ImageDialog(val) {
      if (val == true) {
        this.zoom = 1;
      }
    },
    AllCarDetails(val) {
      if (val == true) {
      }
    },
    async driver_status(val) {
      if (val === "DRIVER_FOUND") {
        await this.GetImage();
        await this.generateImageUrls();
      }
    },
    // "$store.getters.get_subscription_status"(newValue) {
    //   if (newValue === true) {
    //     this.subscribeToNewRequest();
    //   }
    // },
    // async "$store.getters.get_motorist_again"(value) {
    //   console.log("Niran");
    //   if (value === true) {
    //     console.log("niranjan");
    //     this.driver_status = "DRIVER_FOUND";
    //     this.userDetailsObject = this.$store.getters.get_motorist_name;
    //   }
    // },
  },

  async mounted() {
    var UsaStates = require("usa-states").UsaStates;
    var usStates = new UsaStates();
    // this.fetchlocation();
    if (this.$store.getters.get_audio_autoplay == true) {
      this.audioAutoplayMethod();
    }

    this.USAStates = usStates.states;
    this.cardHeight = window.innerHeight - 100;

    setTimeout(() => {
      this.default_state = this.$store.getters.get_current_user_details
        .default_state
        ? this.$store.getters.get_current_user_details.default_state
        : "";
    }, 4000);

    setTimeout(() => {
      console.log("before Subs", this.$store.getters.get_current_user_details);
      if (this.$store.getters.get_subscription_status == true) {
        this.subscribeToNewRequest();
        console.log("Subscribed");
      }
    }, 5000);

    if (this.$store.getters.get_motorist_again === false) {
      this.license_plate_number =
        this.$store.getters.get_car_details.license_plate_number;
      this.userDetailsObject = this.$store.getters.get_motorist_name;
      this.driver_status = "DRIVER_FOUND";
      this.fetchLocationAddress(
        this.$store.getters.get_motorist_name.user_latitude,
        this.$store.getters.get_motorist_name.user_longitude
      );
      // this.validateMethod("REQUEST_ACCESS");
    }
    if (this.$store.getters.get_motorist_boolean === false) {
      this.license_plate_number = "";
    }
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // if (this.$store.getters.get_motorist_boolean == true) {
    //   this.UndoProfileSearch();
    // }
  },

  methods: {
    audioAutoplayMethod() {
      this.AutoPlayDialog = true;
    },
    getLicensePlateText(license_plate_number) {
      if (!license_plate_number) return "";

      const plateArray = license_plate_number
        .split(",")
        .map((plate) => plate.trim());

      if (plateArray.length === 1) {
        return plateArray[0];
      }

      if (plateArray[0] === this.targetPlate) {
        return plateArray[0];
      } else {
        return `${plateArray[0]} + ${plateArray.length - 1} more`;
      }
    },
    async GetImage() {
      if (
        this.userDetailsObject.profile_pic_url.includes(
          "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
        )
      ) {
        const ProfileImg = this.userDetailsObject.profile_pic_url;
        const Frontparts = ProfileImg.split("/");
        const ProfilePicImg = Frontparts.pop();
        this.profile_pic_url = await this.GenerateS3URLMethods(
          `/${ProfilePicImg}`
        );
      } else {
        const Profile_Image = this.userDetailsObject.profile_pic_url;

        console.log("Profile_ImageProfile_Image", Profile_Image);
        this.profile_pic_url = await this.GenerateS3URLMethods(Profile_Image);
      }
      // const ProfileURL = `https://makeithomesafe.s3.us-east-1.amazonaws.com/${Profile_Image}`;
      // return ProfileURL;
    },
    async TableImageMethod(Image) {
      await this.GenerateS3URLMethods(Image);
    },
    async loadTableImage(Image) {
      try {
        const imageUrl = await this.GenerateS3URLMethods(Image);
        this.imageSrc = imageUrl;
      } catch (error) {
        console.error("Error loading table image:", error);
      }
    },
    ChatMethod() {
      this.$router.push("/Chat");
    },
    OpenImageDialog(item) {
      this.ImageSrc = item.imageUrl;
      this.ImageDialog = true;
    },
    handleZoom(event) {
      event.preventDefault();
      const direction = event.deltaY > 0 ? -0.1 : 0.1;
      this.zoom += direction;
      if (this.zoom < 1) {
        this.zoom = 1;
      } else if (this.zoom > 2) {
        this.zoom = 2;
      }
    },
    async generateImageUrls() {
      console.log(
        "this.$store.getters.get_car_details",
        this.$store.getters.get_car_details
      );
      if (this.$store.getters.get_car_details.license_front_url) {
        if (
          this.$store.getters.get_car_details.license_front_url.includes(
            "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
          )
        ) {
          const Licensefront =
            this.$store.getters.get_car_details.license_front_url;
          const Frontparts = Licensefront.split("/");
          const LicensefrontImg = Frontparts.pop();
          this.imageArray[0].imageUrl = await this.GenerateS3URLMethods(
            `/${LicensefrontImg}`
          );
        } else {
          this.imageArray[0].imageUrl = await this.GenerateS3URLMethods(
            `${this.$store.getters.get_car_details.license_front_url}`
          );
        }
      }
      if (this.$store.getters.get_car_details.license_front) {
        if (
          this.$store.getters.get_car_details.license_front.includes(
            "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
          )
        ) {
          const Licensefront =
            this.$store.getters.get_car_details.license_front;
          const Frontparts = Licensefront.split("/");
          const LicensefrontImg = Frontparts.pop();
          this.imageArray[0].imageUrl = await this.GenerateS3URLMethods(
            `/${LicensefrontImg}`
          );
        }
      }
      if (this.$store.getters.get_car_details.license_back_url) {
        if (
          this.$store.getters.get_car_details.license_back_url.includes(
            "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
          )
        ) {
          const LicenseBack =
            this.$store.getters.get_car_details.license_back_url;
          const Backparts = LicenseBack.split("/");
          const LicensebackImg = Backparts.pop();
          this.imageArray[1].imageUrl = await this.GenerateS3URLMethods(
            `/${LicensebackImg}`
          );
        } else {
          this.imageArray[1].imageUrl = await this.GenerateS3URLMethods(
            `${this.$store.getters.get_car_details.license_back_url}`
          );
        }
      }
      if (this.$store.getters.get_car_details.license_back) {
        const LicenseBack = this.$store.getters.get_car_details.license_back;
        const Backparts = LicenseBack.split("/");
        const LicensebackImg = Backparts.pop();
        this.imageArray[1].imageUrl = await this.GenerateS3URLMethods(
          `/${LicensebackImg}`
        );
      }
      if (this.$store.getters.get_car_details.registration_certificate) {
        if (
          this.$store.getters.get_car_details.registration_certificate.includes(
            "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
          )
        ) {
          const Registration =
            this.$store.getters.get_car_details.registration_certificate;
          const Registerparts = Registration.split("/");
          const RegistrationImg = Registerparts.pop();
          this.imageArray[2].imageUrl = await this.GenerateS3URLMethods(
            `/${RegistrationImg}`
          );
        } else {
          this.imageArray[2].imageUrl = await this.GenerateS3URLMethods(
            `${this.$store.getters.get_car_details.registration_certificate}`
          );
        }
      }
      if (this.$store.getters.get_car_details.insurance_certificate) {
        if (
          this.$store.getters.get_car_details.insurance_certificate.includes(
            "https://makeithomesafe.s3.us-east-1.amazonaws.com//"
          )
        ) {
          const Insurance =
            this.$store.getters.get_car_details.insurance_certificate;
          const parts = Insurance.split("/");
          const InsuranceImg = parts.pop();
          this.imageArray[3].imageUrl = await this.GenerateS3URLMethods(
            `/${InsuranceImg}`
          );
        } else {
          this.imageArray[3].imageUrl = await this.GenerateS3URLMethods(
            `${this.$store.getters.get_car_details.insurance_certificate}`
          );
        }
      }
    },
    handleKeyDown(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    },
    // convertCoordinatesToAddressMethod() {
    //   var self = this;
    //   var xhttp = new XMLHttpRequest();
    //   xhttp.open(
    //     "GET",
    //     "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
    //       self.$store.getters.get_motorist_name.user_latitude +
    //       "," +
    //       self.$store.getters.get_motorist_name.user_longitude +
    //       "&key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ",
    //     // AIzaSyBUp8E7OghfEFg9fJ1ePokoOhE1I8MaD-M
    //     true
    //   );
    //   xhttp.send();
    //   xhttp.onreadystatechange = function () {
    //     // if (self.readyState == 4 && self.status == 200) {
    //     var response = self.responseText;
    //     console.log("response", response);
    //     if (response.results && response.results[0]) {
    //       self.address = response.results[0].formatted_address;
    //     } else {
    //       self.address = "Address not found";
    //     }
    //     // }
    //   };
    // },
    async fetchLocationAddress(lat, lng) {
      this.address = await this.convertCoordinatesToAddressMethod(lat, lng);
    },
    convertCoordinatesToAddressMethod(lat, lng) {
      return new Promise((resolve) => {
        const xhttp = new XMLHttpRequest();
        xhttp.open(
          "GET",
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          true
        );
        xhttp.send();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            const response = JSON.parse(this.responseText);
            console.log("response", response);
            if (response.results && response.results[1]) {
              resolve(response.results[1].formatted_address);
            } else {
              resolve("Address not found");
            }
          }
        };
      });
    },
    async validateDefaultStateMethod() {
      if (this.$refs.formDefaultState.validate()) {
        this.loadingDefaultState = true;
        let inputParams = {
          user_id: this.$store.getters.get_current_user_details.user_id,
          default_state: this.default_state,
        };
        let result = await this.updateProfileDetailsMethod(inputParams);
        this.loadingDefaultState = false;
        if (result == "SUCCESS") {
          await this.GetCurrentUser();
          // this.currentUserDetailsObject =
          //   this.$store.getters.get_current_user_details;
          // this.default_state = this.currentUserDetailsObject.default_state
          //   ? this.currentUserDetailsObject.default_state
          //   : "";
        }
      }
    },
    CarDetailsDialog(item) {
      this.StoreObj = item;
      this.CardetailsDialog = true;
    },
    dialogAddViolationEmit() {
      this.dialogAddViolation = false;
    },
    async CarDialogEmit(Toggle) {
      this.CardetailsDialog = false;
      if (Toggle == 2) {
        this.license_plate_number = this.GetNearCarDetails.license_plate_number;
        await this.validateMethod("NUMBER_PLATE");
      }
    },
    async subscribeToNewRequest() {
      // if (this.$store.getters.get_subscription_status == true) {
      this.subscription = await API.graphql(
        graphqlOperation(SubscribeGetNotifications, {
          user_id: this.$store.getters.get_current_user_details.user_id,
        })
      ).subscribe({
        next: async (data) => {
          console.log("dxata", data);
          this.currentUserOject =
            data.value.data.SubscribeGetNotifications.items[0];
          // console.log(" this.currentUserOject", this.currentUserOject);
          switch (this.currentUserOject.notification_type) {
            case "PROFILE_UNHIDED":
              this.SnackBarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "green",
                Top: true,
                SnackbarText: "Profile Access Granted",
              };

              this.driver_status = await this.GetVehicleDetailsMethod(
                this.license_plate_number
              );
              // await this.GetImage();
              // await this.generateImageUrls();
              break;
            case "NEARBY_MOTORISTS":
              let latestItemsMap = {};

              const currentTime = new Date();

              data.value.data.SubscribeGetNotifications.items.forEach((obj) => {
                const createdOnTime = new Date(obj.created_on * 1000);
                const timeDifferenceMinutes =
                  Math.abs(currentTime - createdOnTime) / (1000 * 60);

                if (
                  timeDifferenceMinutes < 2 &&
                  (!latestItemsMap[obj.notification_by] ||
                    createdOnTime >
                      new Date(
                        latestItemsMap[obj.notification_by].created_on * 1000
                      ))
                ) {
                  latestItemsMap[obj.notification_by] = obj;
                }
              });

              let latestItems = Object.values(latestItemsMap);

              this.GetAllMotoristsList = latestItems;

              // console.log("latestItems", latestItems);
              // for (let i = 0; i < this.GetAllMotoristsList.length; i++) {
              //   this.GetAllMotoristsList.profile_pic_url =
              //     this.ViewImageDetailsMethod(
              //       this.GetAllMotoristsList[i].notification_by
              //     );
              // }
              // console.log("this.GetAllMotoristsList", this.GetAllMotoristsList);
              this.AllCarDetails = true;
              // var audio = new Audio(whatsappNotificationSound);
              // audio.play();
              var video = document.getElementById("myVideo");
              video.play();
              setTimeout(() => {
                // var VoiceVideo = document.getElementById("myVideo1");
                // VoiceVideo.play();
                var audio = document.getElementById("myVideo1");
                audio.muted = false;
                audio.play().catch((error) => {
                  console.error("Error playing audio:", error);
                });
              }, 1400);

              // var ActivateAudio = new Audio(ActivatedVoice);
              // ActivateAudio.play();
              // var utterance = new SpeechSynthesisUtterance(
              //   "Make It Home Safe Activated"
              // );
              // speechSynthesis.speak(utterance);
              break;
            case "RECIEVED_VIOLATION":
              this.Acknowledged = true;
              break;
            case "NEW_MESSAGE":
              if (
                this.currentUserOject.notification_by ==
                this.$store.getters.get_motorist_name.user_id
              ) {
                this.MessageNotification = true;
              }
              break;
            case "VIDEO_CALL_INITIATED":
              if (
                this.currentUserOject.notification_by ==
                this.$store.getters.get_motorist_name.user_id
              ) {
                this.subscribeToRecieveVideoCall();
                this.VideoCallDialog = true;
              }
              break;
            case "MOTORIST_ALERTS":
              if (
                this.currentUserOject.notification_by ==
                this.$store.getters.get_motorist_name.user_id
              ) {
                this.WarningNotification = true;
              }
              break;
          }
        },
        error: (error) => {
          console.warn("Check the error", error);
        },
      });
      // }
    },
    async requestAccessMethod() {
      var inputParams = {
        user_id: this.$store.getters.get_current_user_details.user_id,
        license_plate_number: this.license_plate_number,
        notification_message: "Police Has Requested To Access Your Profile",
      };
      try {
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(RequestForProfile, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.RequestForProfile);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: ResultObject.message,
        };
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (
          error.errors[0].message ==
          "Motorist Profile Is Already Open To See !!"
        ) {
          this.validateMethod("NUMBER_PLATE");
        }
      }
    },
    async validateMethod(ACTION) {
      if (this.license_plate_number != "") {
        switch (ACTION) {
          case "NUMBER_PLATE":
            this.driver_status = await this.GetVehicleDetailsMethod(
              this.license_plate_number
            );
            break;
          case "REQUEST_ACCESS":
            this.requestAccessMethod();
            break;
        }
      }
    },
    // fetchlocation() {
    //   if (
    //     this.$store.getters.get_current_user_details.user_status == "ACTIVE"
    //   ) {
    //     if ("geolocation" in navigator) {
    //       navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //           this.overlay = true;
    //           this.currentLocation.lat = position.coords.latitude;
    //           this.currentLocation.lng = position.coords.longitude;
    //           this.GetAllNearMotoristMethod(
    //             this.currentLocation.lat,
    //             this.currentLocation.lng
    //           );
    //           // this.convertCoordinatesToAddress();
    //         },
    //         (error) => {
    //           if (error.code === error.PERMISSION_DENIED) {
    //             this.SnackBarComponent = {
    //               SnackbarVmodel: true,
    //               SnackbarColor: "red",
    //               Top: true,
    //               SnackbarText: "Enable location to get nearist motorists",
    //             };
    //           }
    //         }
    //       );
    //     }
    //   }
    // },
    async ViewDetailsMethod(item) {
      const plates = item.license_plate_number
        .split(",")
        .map((plate) => plate.trim());

      if (plates.length === 1) {
        this.license_plate_number = plates[0];
        await this.validateMethod("NUMBER_PLATE");
      } else {
        this.GetNearCarDetailsMethod(
          item.notification_by,
          item.notified_by_user_name
        );
      }
      // this.AnyCarDetailsDialog = true;
      // if (this.GetNearCarDetails.length != 0) {
      //   this.CardetailsNear = this.GetNearCarDetails.filter((Unique) => {
      //     Unique.user_id == item.user_id;
      //   });
      //   console.log("this.CardetailsNear", this.CardetailsNear);
      // }
    },
    ChatDialogEmit() {
      this.Chatdialog = false;
    },
    async AnyCarDialogEmit(Toggle, item) {
      this.AnyCarDetailsDialog = false;
      if (Toggle == 2) {
        this.license_plate_number = item;
        await this.validateMethod("NUMBER_PLATE");
      }
    },
    UndoProfileSearch() {
      this.driver_status = "";
      this.$refs.form.reset();
      this.$store.commit("SET_MOTORIST_AGAIN", true);
      this.$store.commit("SET_MOTORIST_NAME", {});
      this.$store.commit("SET_CHAT_LIST", {});
      this.SetMyLocation();

      setTimeout(() => {
        this.RecordDetailsOfPoliceMethod();
      }, 2000);
      console.log("completedata", this.$store.getters.get_complete_data);
    },
    async getPublicIP() {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        const ipAddress = response.data.ip;
        console.log("Public IP Address:", ipAddress);
        return ipAddress;
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    },
    async SetMyLocation() {
      try {
        const payload = {
          considerIp: "true",
        };

        const response = await axios.post(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          payload
        );
        const { lat, lng } = response.data.location;

        let EndLocation = [
          lat,
          lng,
          await this.convertCoordinatesToAddress(lat, lng),
        ];
        let EndTime = new Date().getTime();
        let TotalDuration = await this.durationMethod(EndTime);
        let monthName = new Date().getMonth() + 1;
        const months = [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
        ];

        let FullMonth = months[monthName - 1];
        let FullYear = new Date().getFullYear();

        this.$store.commit("SET_COMPLETE_DATA", {
          EndTime,
          EndLocation,
          TotalDuration,
          FullMonth,
          FullYear,
        });
      } catch (error) {
        console.log(error);
      }
    },
    durationMethod(item) {
      const diffMs = item - this.$store.getters.get_complete_data.StartDate;

      const minutes = Math.floor(diffMs / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      const formattedDuration = minutes + seconds / 100;

      return formattedDuration;
    },

    convertCoordinatesToAddress(lat, lng) {
      return new Promise((resolve) => {
        const xhttp = new XMLHttpRequest();
        xhttp.open(
          "GET",
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          true
        );
        xhttp.send();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            const response = JSON.parse(this.responseText);
            if (response.results && response.results[0]) {
              resolve(response.results[0].formatted_address);
            } else {
              resolve("Address not found");
            }
          }
        };
      });
    },
    AcknowledgedEmit() {
      this.Acknowledged = false;
    },
    FirstMessageEmit() {
      this.MessageNotification = false;
    },
    VideoCallEmit() {
      this.VideoCallDialog = false;
    },
    AlertDialogEmit() {
      this.WarningNotification = false;
    },
    AudioPlay() {
      var audio = document.getElementById("myVideo1");
      audio.muted = true;
      audio.play();
      this.AutoPlayDialog = false;
      this.$store.commit("SET_AUDIO_AUTOPLAY", false);
    },
  },
};
</script>

<style scoped>
.responsive-image {
  min-height: 100vh;
  min-width: 100vw;
}
</style>
